import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

// import vue-bootstrap
import BootstrapVue from 'bootstrap-vue'
import './styles/style-variable.scss'

// import RXJS to improve reactivity and performance
import VueRx from 'vue-rx'
import VueCookies from 'vue-cookies'
import Analytic from './plugins/trackEvent'

Vue.use(BootstrapVue)
Vue.use(VueRx)
Vue.use(VueCookies)
Vue.use(Analytic)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
